/* TooCut PDP v3.2 — buy box, accordion, featured reviews carousel,
   sticky mobile CTA, idle preloads, per-product rating override,
   selling plan plumbing, Mux player IG-style autoplay-on-scroll.
   v3.1 fix: empty cart → first add → drawer opens but visually empty.
   v3.2: Pack-tile sub-labels update on mode toggle.
     - sub mode: 1pk='monthly', 3pk='every 3 mo', 6pk='every 6 mo'
     - one-time: 1pk='' (NBSP for layout), 3pk='3 month supply', 6pk='6 month supply'
*/
(function() {
  var root = document.querySelector('.tcp');
  if (!root) return;

  (function setRating() {
    var meta = root.querySelector('.tcp-toprating__meta');
    if (!meta) return;
    var m = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (!m) return;
    var handle = m[1].replace('-m2-preview', '');
    var ratings = {
      'toocut-women-s-amplifier': '4.74 · 18,000+ verified buyers',
      'toocut-men-s-amplifier':   '4.89 · 19,000+ verified buyers',
      'toocut-detox':             '4.91 · 10,000+ verified buyers',
      'toocut-brain-booster':     '4.93 · 8,500+ verified buyers',
      'toocut-crown-elixir':      '5.00 · 1,200+ verified buyers'
    };
    var r = ratings[handle];
    if (r) meta.textContent = r;
  })();

  var mode = 'sub';
  var pack = 3;
  var fmt = function(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function readPriceData(card, m, p) { return parseFloat(card.getAttribute('data-' + m + '-' + p)); }
  function readAnchor(card, p) { return parseFloat(card.getAttribute('data-anchor-' + p)); }
  function readSellingPlan(card, p) { return parseInt(card.getAttribute('data-selling-plan-' + p), 10) || null; }

  $$('.tcp-mode__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var newMode = btn.dataset.mode;
      if (newMode === mode) return;
      mode = newMode;
      $$('.tcp-mode__btn').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      renderBuyBox();
    });
  });

  $$('.tcp-pack').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var p = parseInt(btn.dataset.pack, 10);
      pack = p;
      $$('.tcp-pack').forEach(function(b) { b.classList.toggle('is-active', b === btn); });
      renderBuyBox();
    });
  });

  function renderBuyBox() {
    $$('.tcp-pack').forEach(function(card) {
      var p = parseInt(card.dataset.pack, 10);
      var sub = readPriceData(card, 'sub', p);
      var one = readPriceData(card, 'one', p);
      var price = mode === 'sub' ? sub : one;
      var priceEl = card.querySelector('.tcp-pack__price');
      if (priceEl) priceEl.textContent = fmt(price);
      var saveEl = card.querySelector('.tcp-pack__save');
      if (saveEl) {
        var saveVal = parseInt(mode === 'sub' ? saveEl.dataset.saveSub : saveEl.dataset.saveOne, 10) || 0;
        if (saveVal > 0) {
          saveEl.textContent = 'save $' + saveVal;
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
      // v3.2: pack-tile sub-label swap per mode
      var subEl = card.querySelector('.tcp-pack__sub');
      if (subEl) {
        var subText;
        if (mode === 'sub') {
          subText = p === 1 ? 'monthly' : ('every ' + p + ' mo');
        } else {
          subText = p === 1 ? ' ' : (p + ' month supply');
        }
        subEl.textContent = subText;
      }
    });

    var packData = $('.tcp-pack[data-pack="' + pack + '"]');
    if (!packData) return;
    var sub = readPriceData(packData, 'sub', pack);
    var one = readPriceData(packData, 'one', pack);
    var anchor = readAnchor(packData, pack);
    var price = mode === 'sub' ? sub : one;
    var compare = (anchor && anchor > price) ? anchor : null;

    var priceEl = $('.tcp-price');
    var compareEl = $('.tcp-price-compare');
    var metaEl = $('.tcp-price-meta');
    var ctaEl = $('.tcp-cta');

    if (priceEl) priceEl.textContent = fmt(price);
    if (compareEl) {
      if (compare && compare > price) { compareEl.textContent = fmt(compare); compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    if (metaEl) {
      metaEl.textContent = pack + '-pack · ' + (mode === 'sub' ? (pack === 1 ? 'monthly delivery' : 'every ' + pack + ' months') : pack + ' mo supply');
    }
    if (ctaEl) {
      var variantId = packData.dataset.variantId;
      if (variantId && variantId !== '') {
        ctaEl.disabled = false;
        ctaEl.textContent = 'Add to Cart — ' + fmt(price);
        ctaEl.dataset.variantId = variantId;
      } else {
        ctaEl.disabled = true;
        ctaEl.textContent = 'Variant unavailable';
      }
    }

    var stickyPriceMain = $('.tcp-sticky__price-main');
    var stickyPriceMeta = $('.tcp-sticky__price-meta');
    var stickyCta = $('.tcp-sticky__cta');
    if (stickyPriceMain) stickyPriceMain.textContent = fmt(price);
    if (stickyPriceMeta) stickyPriceMeta.textContent = pack + '-pack · ' + (mode === 'sub' ? 'sub' : 'one-time');
    if (stickyCta) {
      stickyCta.disabled = ctaEl ? ctaEl.disabled : false;
      stickyCta.dataset.variantId = (ctaEl && ctaEl.dataset.variantId) || '';
    }
  }

  function getDrawerSectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function(s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(triggerBtn) {
    if (!triggerBtn || triggerBtn.disabled) return;
    var variantId = triggerBtn.dataset.variantId;
    if (!variantId) return;
    var originalText = triggerBtn.textContent;
    triggerBtn.disabled = true;
    triggerBtn.textContent = 'Adding…';

    var packData = $('.tcp-pack[data-pack="' + pack + '"]');
    var sellingPlanId = null;
    if (mode === 'sub' && packData) {
      sellingPlanId = readSellingPlan(packData, pack);
    }
    var mainItem = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlanId) mainItem.selling_plan = sellingPlanId;

    var body = {
      items: [mainItem],
      sections: getDrawerSectionIds().join(','),
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data }; });
    }).then(function(resp) {
      if (!resp.ok) {
        var msg = (resp.data && (resp.data.description || resp.data.message)) || 'Cart add failed';
        throw new Error(msg);
      }
      triggerBtn.textContent = '✓ Added to cart';
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && resp.data && resp.data.sections) {
        drawer.renderContents(resp.data);
        if (drawer.classList.contains('is-empty')) {
          drawer.classList.remove('is-empty');
        }
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      setTimeout(function() {
        triggerBtn.disabled = false;
        triggerBtn.textContent = originalText;
      }, 1800);
    }).catch(function(err) {
      triggerBtn.disabled = false;
      triggerBtn.textContent = 'Try again';
      console.error('Cart add failed:', err);
    });
  }

  var ctaBtn = $('.tcp-cta');
  if (ctaBtn) ctaBtn.addEventListener('click', function() { addToCart(ctaBtn); });
  var stickyBtn = $('.tcp-sticky__cta');
  if (stickyBtn) stickyBtn.addEventListener('click', function() { addToCart(stickyBtn); });

  var stickyEl = $('.tcp-sticky');
  function updateStickyVisibility() {
    if (!stickyEl) return;
    if (window.innerWidth > 749) { stickyEl.classList.remove('is-visible'); return; }
    if (!ctaBtn) return;
    var rect = ctaBtn.getBoundingClientRect();
    if (rect.bottom < window.innerHeight * 0.3) {
      stickyEl.classList.add('is-visible');
      stickyEl.setAttribute('aria-hidden', 'false');
    } else {
      stickyEl.classList.remove('is-visible');
      stickyEl.setAttribute('aria-hidden', 'true');
    }
  }
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  window.addEventListener('resize', updateStickyVisibility);

  function idlePreload() {
    $$('.tcp-gallery__thumb').forEach(function(thumb) {
      var src = thumb.dataset.full;
      if (src) { var im = new Image(); im.src = src; }
    });
    $$('.tcp-acc__ing-img img').forEach(function(img) {
      if (img.src) { var im = new Image(); im.src = img.src; }
    });
    $$('.tcp-featrev__photo img').forEach(function(img) {
      if (img.src) { var im = new Image(); im.src = img.src; }
    });
  }
  if ('requestIdleCallback' in window) { requestIdleCallback(idlePreload, { timeout: 2500 }); }
  else { setTimeout(idlePreload, 1500); }

  $$('.tcp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = $('.tcp-gallery__main img');
      if (mainImg) {
        mainImg.classList.add('is-swapping');
        setTimeout(function() { mainImg.classList.remove('is-swapping'); }, 200);
      }
    }, true);
  });

  (function carousel() {
    var viewport = $('.tcp-featrevs__viewport');
    var track = $('.tcp-featrevs__track');
    if (!viewport || !track) return;
    var slides = $$('.tcp-featrev', track);
    if (slides.length === 0) return;
    var dotsEl = $('.tcp-featrevs__dots');
    var idx = 0;
    var autoTimer = null;
    var AUTO_MS = 4000;
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      slides.forEach(function(_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'tcp-featrevs__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to review ' + (i + 1));
        d.addEventListener('click', function() { goTo(i, true); });
        dotsEl.appendChild(d);
      });
    }
    function goTo(i, userInitiated) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      $$('.tcp-featrevs__dot', dotsEl).forEach(function(d, n) { d.classList.toggle('is-active', n === idx); });
      if (userInitiated) restartAuto();
    }
    function next() { goTo(idx + 1, false); }
    function prev() { goTo(idx - 1, true); }
    function startAuto() { stopAuto(); autoTimer = setInterval(next, AUTO_MS); }
    function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
    function restartAuto() { stopAuto(); startAuto(); }
    var prevBtn = $('.tcp-featrevs__arrow--prev');
    var nextBtn = $('.tcp-featrevs__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(idx + 1, true); });
    var startX = null;
    viewport.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; stopAuto(); }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { if (dx < 0) goTo(idx + 1, true); else prev(); } else { startAuto(); }
      startX = null;
    }, { passive: true });
    viewport.addEventListener('mouseenter', stopAuto);
    viewport.addEventListener('mouseleave', startAuto);
    buildDots();
    startAuto();
  })();

  // Mux IG-style autoplay-on-scroll + audio-follows-scroll
  function setupMuxAutoplay() {
    var muxNodes = $$('mux-player.tcp-vid__mux');
    if (muxNodes.length === 0) return;
    var audioOn = false;
    var explicitTarget = null;
    var ratios = new Map();
    muxNodes.forEach(function(p) { ratios.set(p, 0); });

    function getCard(player) { return player.closest('.tcp-vid'); }
    function setCardUnmutedUI(card, isUnmuted) {
      if (!card) return;
      card.classList.toggle('is-unmuted', isUnmuted);
    }
    function getMostVisible() {
      var max = -1, winner = null;
      muxNodes.forEach(function(p) {
        var r = ratios.get(p) || 0;
        if (r > max) { max = r; winner = p; }
      });
      return winner;
    }
    function getAudioTarget() {
      if (!audioOn) return null;
      if (explicitTarget && (ratios.get(explicitTarget) || 0) >= 0.5) return explicitTarget;
      return getMostVisible();
    }
    function applyAudioRouting() {
      var target = getAudioTarget();
      muxNodes.forEach(function(p) {
        var shouldMute = (p !== target);
        try { p.muted = shouldMute; } catch (e) {}
        setCardUnmutedUI(getCard(p), !shouldMute);
      });
    }

    muxNodes.forEach(function(player) {
      var card = getCard(player);
      var unmuteBtn = card ? card.querySelector('.tcp-vid__unmute') : null;
      if (!unmuteBtn) return;
      unmuteBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (audioOn && explicitTarget === player) {
          audioOn = false;
          explicitTarget = null;
        } else {
          audioOn = true;
          explicitTarget = player;
        }
        applyAudioRouting();
      });
    });

    if (!('IntersectionObserver' in window)) {
      muxNodes.forEach(function(p) { try { p.play(); } catch (e) {} });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var player = entry.target;
        ratios.set(player, entry.intersectionRatio);
        try {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            player.play && player.play().catch(function() {});
          } else {
            player.pause && player.pause();
          }
        } catch (e) {}
      });
      if (audioOn) applyAudioRouting();
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    muxNodes.forEach(function(p) { io.observe(p); });
    applyAudioRouting();
  }
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('mux-player').then(setupMuxAutoplay).catch(setupMuxAutoplay);
  } else {
    setTimeout(setupMuxAutoplay, 1000);
  }

  $$('.tcp-vid').forEach(function(card) {
    var btn = card.querySelector('.tcp-vid__play');
    var vid = card.querySelector('.tcp-vid__video');
    if (!btn || !vid) return;
    btn.addEventListener('click', function() {
      btn.style.display = 'none';
      vid.setAttribute('controls', '');
      try { vid.play(); } catch (e) {}
    });
  });

  var mainImg = $('.tcp-gallery__main img');
  $$('.tcp-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.dataset.full || thumb.querySelector('img').src;
      if (mainImg) mainImg.src = src;
      $$('.tcp-gallery__thumb').forEach(function(t) { t.classList.toggle('is-active', t === thumb); });
    });
  });

  renderBuyBox();
  updateStickyVisibility();
})();
